<template>
  <v-dialog v-model="showDialog" max-width="700">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="isUnsubscribed"
        small
        rounded
        :color="feature.subscribe.color"
        class="mx-1"
        v-bind="attrs"
        v-on="on"
        @click="showDialogClick"
      >
        <span class="mr-1">{{ buttonText }}</span>
        <v-icon>{{ feature.subscribe.icon }}</v-icon>
      </v-btn>
    </template>

    <v-dialog v-model="showDialog" :width="feature.subscribe.dialogWidth">
      <SubscriptionEditor
        :isDialogOpen="showDialog"
        @close="subscriptionEditorCloseEvent"
        @update="subscriptionEditorUpdateEvent"
      />
    </v-dialog>
  </v-dialog>
</template>

<script>
import { ref, computed } from 'vue'
import { feature } from '@/use/Constants'
import SubscriptionEditor from '@/components/Setup/Office/SubscriptionEditor'
export default {
  name: 'SubscribeButton',
  components: { SubscriptionEditor },
  setup() {
    // TODO: Logic to know when to show this button
    const isUnsubscribed = ref(false)
    const showDialog = ref(false)

    const showDialogClick = () => {
      showDialog.value = true
    }

    const buttonText = computed(() => {
      return '10 Days Left -- Subscribe Now!'
    })

    const subscriptionEditorCloseEvent = () => {
      showDialog.value = false
    }

    const subscriptionEditorUpdateEvent = () => {
      showDialog.value = false
    }

    return {
      feature,
      showDialog,
      showDialogClick,
      buttonText,
      isUnsubscribed,
      subscriptionEditorCloseEvent,
      subscriptionEditorUpdateEvent
    }
  }
}
</script>

<style lang="scss" scoped></style>
